import { createContext, type Context } from 'react';

import { SUGGESTIONS_TAB_ID } from '../chat-history/rovo-tabs/constants';

import type { ActiveTabContextValue } from './ActiveTabContextValue';

export const ActiveTabContext: Context<ActiveTabContextValue> =
	createContext<ActiveTabContextValue>({
		activeTabId: SUGGESTIONS_TAB_ID,
		handleActiveTabChange: () => {},
		resetToPreviousTab: () => {},
	});
